<template>
  <div class="footer-bar">
    <div class="top">
      <div class="list">
        <div class="title" @click="navigation({name: 'Server'})">服务介绍</div>
        <div class="i" @click.stop="navigation({name: 'Server', query: {selected: 'TOP'}})">运营模式</div>
        <div class="i" @click="navigation({name: 'Server', query: {selected: 'EP'}})">入场准备</div>
        <div class="i" @click="navigation({name: 'Server', query: {selected: 'PA'}})">平台优势</div>
      </div>
      <div class="list">
        <div class="title" @click="navigation({name: 'Product'})">产品介绍</div>
        <div class="i" @click="navigation({name: 'Product', query: {selected: 0}})">产品</div>
        <div class="i" @click="navigation({name: 'Product', query: {selected: 1}})">iDAS</div>
        <div class="i" @click="navigation({name: 'Product', query: {selected: 2}})">自主硬件研发</div>
      </div>
      <div class="list">
        <div class="title" @click="navigation({name: 'About'})">关于我们</div>
        <div class="i" @click="navigation({name: 'About', query: {selected: 0}})">企业介绍</div>
        <!-- <div class="i" @click="navigation({name: 'About', query: {selected: 1}})">工作机会</div> -->
        <div class="i" @click="navigation({name: 'About', query: {selected: 2}})">联系我们</div>
      </div>
      <div class="qr">
        <img src=@/assets/footer-bar/qr.png alt="">
        <div class="text">扫一扫，关注我们</div>
      </div>
    </div>
    <div class="bottom"><span>上海玺拓软件科技有限公司@版权所有</span><a style="color: #B3B3B3; text-decoration: none; margin-left: 10px;" href="https://beian.miit.gov.cn/">沪ICP备16020352号-2</a></div>
    <div class="bottom">
     <a class="bottom" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011702007907" style="color: #B3B3B3; text-decoration: none;">
      <img src="@/assets/home/beian.png" style="width: 20px; margin-right: 10px;"/>
      <span>沪公网安备 31011702007947号</span>
     </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'footer-bar',
  components: {

  },
  methods: {
    /**
     * 页面跳转
     */
    navigation (url) {
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.footer-bar {
  color: #B3B3B3;
  text-align: left;
}
.footer-bar .top {
  height: 16rem;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #363A45;
}
.footer-bar .list + .list {
  margin-left: 10rem;
}
.footer-bar .qr {
  width: 10rem;
  text-align: center;
  color: #FFFFFF;
  font-size: 1.2rem;
  margin-left: 60rem;
}
.footer-bar .top .title {
  font-size: 1.6rem;
  color: #FFFFFF;
}
.footer-bar .top .title:hover {
  text-decoration: underline;
}
.footer-bar .i:hover {
  text-decoration: underline;
}
.footer-bar .top .i {
  padding-top: 1rem;
}
.footer-bar .bottom {
  height: 4rem;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2D313C;
}
.footer-bar .bottom span + .i {
  margin-left: 5.4rem;
}
.footer-bar .qr .text {
  margin-top: 1rem;
}
</style>
